import { Link } from 'react-router-dom';

export default function BlogCard({ blog }) {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const getExcerpt = (content, maxLength = 150) => {
    if (!content) return '';
    const stripped = content.replace(/<[^>]*>/g, '').trim();
    if (stripped.length <= maxLength) return stripped;
    return stripped.substring(0, maxLength) + '...';
  };

  const getReadingTime = (content) => {
    if (!content) return '1 min read';
    const words = content.trim().split(/\s+/).length;
    const minutes = Math.ceil(words / 200);
    return `${minutes} min read`;
  };

  return (
    <Link
      to={`/blog/${blog.id}`}
      className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full"
    >
      {/* Blog Image Placeholder */}
      <div className="relative h-48 sm:h-56 overflow-hidden bg-gradient-to-br from-purple-400 via-pink-500 to-orange-500">
        <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-gradient-to-br group-hover:from-black group-hover:to-blue-900 group:hover transition-all duration-300"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <svg
            className="w-16 h-16 text-white opacity-50 group-hover:opacity-70 transition-opacity"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
            />
          </svg>
        </div>
        
        {/* Date Badge */}
        {blog.publishedAt && (
          <div className="absolute top-4 left-4 bg-white px-3 py-1 rounded-full shadow-lg">
            <span className="text-xs font-semibold text-gray-900">
              {formatDate(blog.publishedAt)}
            </span>
          </div>
        )}
      </div>

      {/* Blog Content */}
      <div className="p-5 sm:p-6 flex flex-col flex-1">
        {/* Author & Reading Time */}
        <div className="flex items-center text-sm text-gray-500 mb-3">
          {blog.author && (
            <>
              <div className="flex items-center">
                <svg
                  className="w-4 h-4 mr-1"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                <span>{blog.author}</span>
              </div>
              <span className="mx-2">•</span>
            </>
          )}
          <div className="flex items-center">
            <svg
              className="w-4 h-4 mr-1"
              stroke="currentColor" fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>{getReadingTime(blog.content)}</span>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
          {blog.title}
        </h3>

        {/* Excerpt */}
        {blog.content && (
          <p className="text-gray-600 text-sm sm:text-base mb-4 line-clamp-3 flex-1">
            {getExcerpt(blog.content)}
          </p>
        )}

        {/* Read More Link */}
        <div className="flex items-center text-blue-600 font-semibold text-sm group-hover:text-blue-700 mt-auto">
          Read More
          <svg
            className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform group-hover:animate-ping"
           
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </div>
      </div>
    </Link>
  );
}